// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Preferences_prefSidebar__7aNJT {
  padding: 1.5rem 0rem;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 245px);
  margin-bottom: 23px;
  background-color: #22272a;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  margin-top: -2px;
}

.Preferences_wrapper__v9o5d {
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding: 1.5rem;
  padding-right: 0px !important;
}

.Preferences_prefTabButton__gS4db {
  height: 60px;
  text-align: left;
  text-indent: 5px;
  border-radius: 0px;
  border: none !important;
  background-color: #22272a;

  &:hover {
    background-color: #383c3f;
    font-weight: bold;
  }
}

.Preferences_prefTabButton_selected__z-NA5 {
  height: 60px;
  text-align: left;
  text-indent: 5px;
  border-radius: 0px;
  border: none !important;
  background-color: #383c3f;
  font-weight: bold;
}

h1 {
  margin-bottom: 0.5rem;
}

.Preferences_headerLine__3I8DI {
  border-bottom: 2px solid #e7e0f1;
  margin: 0px;
  margin-left: 10px;
}

/* Mobile */
@media (max-width: 767px) {
  .Preferences_wrapper__v9o5d {
    padding: 1.5rem 0.5rem 2rem 0.5rem;
  }

  .Preferences_prefSidebar__7aNJT {
    visibility: hidden;
    min-height: 0px;
    height: 0px;
    margin: 0px;
    padding: 0px;
  }

  .Preferences_headerLine__3I8DI {
    margin-left: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Preferences.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;;EAEzB;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".prefSidebar {\n  padding: 1.5rem 0rem;\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 245px);\n  margin-bottom: 23px;\n  background-color: #22272a;\n  border-top-left-radius: 15px;\n  border-bottom-left-radius: 15px;\n  margin-top: -2px;\n}\n\n.wrapper {\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n  padding: 1.5rem;\n  padding-right: 0px !important;\n}\n\n.prefTabButton {\n  height: 60px;\n  text-align: left;\n  text-indent: 5px;\n  border-radius: 0px;\n  border: none !important;\n  background-color: #22272a;\n\n  &:hover {\n    background-color: #383c3f;\n    font-weight: bold;\n  }\n}\n\n.prefTabButton_selected {\n  height: 60px;\n  text-align: left;\n  text-indent: 5px;\n  border-radius: 0px;\n  border: none !important;\n  background-color: #383c3f;\n  font-weight: bold;\n}\n\nh1 {\n  margin-bottom: 0.5rem;\n}\n\n.headerLine {\n  border-bottom: 2px solid #e7e0f1;\n  margin: 0px;\n  margin-left: 10px;\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .wrapper {\n    padding: 1.5rem 0.5rem 2rem 0.5rem;\n  }\n\n  .prefSidebar {\n    visibility: hidden;\n    min-height: 0px;\n    height: 0px;\n    margin: 0px;\n    padding: 0px;\n  }\n\n  .headerLine {\n    margin-left: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prefSidebar": `Preferences_prefSidebar__7aNJT`,
	"wrapper": `Preferences_wrapper__v9o5d`,
	"prefTabButton": `Preferences_prefTabButton__gS4db`,
	"prefTabButton_selected": `Preferences_prefTabButton_selected__z-NA5`,
	"headerLine": `Preferences_headerLine__3I8DI`
};
export default ___CSS_LOADER_EXPORT___;
